import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { LogIn, ArrowLeft } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="w-full max-w-md p-8 bg-white border-2 border-black" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'var(--heading-font)' }}>
            ADMIN LOGIN
          </h1>
          <p className="text-zinc-600">STUDIO AT THE THIRD</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={credentials.email}
              onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
              required
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              required
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[var(--accent)] text-black hover:bg-[var(--accent-hover)] rounded-full px-8 py-4 text-lg font-bold transition-transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
            data-testid="admin-login-btn"
          >
            <LogIn size={20} />
            LOGIN
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/admin/forgot-password" className="text-sm font-medium underline text-zinc-700 hover:text-black" data-testid="forgot-password-link">
            Forgot Password?
          </Link>
        </div>

        <div className="mt-8 pt-6 border-t border-zinc-200 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-zinc-600 hover:text-black transition-colors" data-testid="back-to-website-link">
            <ArrowLeft size={16} />
            Back to Website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;